import * as React from "react";

import { IThemeInterface, ThemeProvider } from "~/styled";

import { NormalizedCacheObject } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { I18nextProvider } from "react-i18next";
import { HashRouter } from "react-router-dom";
import { i18n } from "~/i18n";
import Routes from "~/routes";

interface IProps {
  client: ApolloClient<NormalizedCacheObject>;
  theme: IThemeInterface;
}

export default class Root extends React.Component<IProps> {
  public render() {
    const { theme, client } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <ApolloProvider client={client}>
          <I18nextProvider i18n={i18n}>
            <HashRouter>
              <Routes />
            </HashRouter>
          </I18nextProvider>
        </ApolloProvider>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Root.tsx